import { SortableFilter }          from './../common/sortable-filter';

export class ProductSortableFilter extends SortableFilter {
    public page = 0;
    public pageSize = 0;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-list/product-sortable-filter.ts